import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import FileUploadBox from "./components/FileUploadBox";
import DraggableSelectList from "./quizSystem/questionsSection/components/QuestionListDropdown";
import { useSelector, useDispatch } from "react-redux";
import { fetchActiveQuestions } from "../store/reducers/questionsSectionSlice";

const ClientType = [
  { value: "Business", label: "Business" },
  { value: "Sport", label: "Sport" },
  { value: "Private", label: "Private" },
];

const Purpose = [
  { value: "First Aid", label: "First Aid" },
  { value: "Emergency Service", label: "Emergency Service" },
  { value: "Cyber", label: "Cyber" },
  { value: "Machines", label: "Machines" },
];

const Lang = [
  { value: "Danish", label: "Danish" },
  { value: "English", label: "English" },
];

const Format = [
  { value: "A6", label: "A6" },
  { value: "A7", label: "A7" },
  { value: "Tailored", label: "Tailored" },
];

const Standard = [
  { value: "Standard", label: "Standard" },
  { value: "Tailored", label: "Tailored" },
];

const Country = [
  { value: "Denmark", label: "Denmark" },
  { value: "US", label: "US" },
  { value: "UK", label: "UK" },
  { value: "Canada", label: "Canada" },
  { value: "Australia", label: "Australia" },
  { value: "South Africa", label: "South Africa" },
  { value: "New Zealand", label: "New Zealand" },
];

const findOption = (options, value) => {
  if (!value) return null;
  return (
    options.find(
      (option) => option.label === value || option.value === value,
    ) || { label: value, value }
  );
};

const normalizeMultiSelectValue = (value, options) => {
  if (!value) return [];

  let parsedValue = value;

  if (typeof value === "string") {
    try {
      parsedValue = JSON.parse(value);
    } catch {
      parsedValue = [value];
    }
  }

  if (!Array.isArray(parsedValue)) {
    parsedValue = [parsedValue];
  }

  return parsedValue
    .map((item) => {
      if (!item) return null;
      if (typeof item === "object" && item.label) {
        return findOption(options, item.label);
      }
      return findOption(options, item);
    })
    .filter(Boolean);
};

const getLabels = (selected) =>
  Array.isArray(selected) ? selected.map((item) => item.label) : [];

const createCountryPdfSection = (sectionId = 1, overrides = {}) => ({
  id: sectionId,
  sectionId,
  countries: [Country[0]],
  standard: Standard[0],
  version: "",
  frontFile: null,
  backFile: null,
  ...overrides,
});

const AddSingleActionCard = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { search } = useLocation();

  const paramIdSeprator = (param) => {
    const paramId = param.split("=");
    return paramId[1];
  };

  const [clientTypes, setClientTypes] = useState([ClientType[0]]);
  const [formats, setFormats] = useState([Format[0]]);
  const [purposes, setPurposes] = useState(null);
  const [langs, setLangs] = useState([Lang[0]]);
  const [remark, setRemark] = useState("");
  const [countrys, setCountrys] = useState([Country[0]]);
  const [standards, setStandards] = useState(Standard[0]);
  const [versionNumber, setVersionNumber] = useState("");
  const [ac_no, setAc_no] = useState();
  const [files] = useState([]);
  const [engName, setEngName] = useState("");
  const [engShortName, setEngShortName] = useState("");
  const [danishName, setDanishName] = useState("");
  const [danishShortName, setDanishShortName] = useState("");
  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [defaultSectionId, setDefaultSectionId] = useState(1);
  const [countryPdfSections, setCountryPdfSections] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedQuestionIds, setSelectedQuestionIds] = useState([]);
  const [defaultQuestionIds, setDefaultQuestionIds] = useState([]);
  const [sectionErrors, setSectionErrors] = useState({});
  const { activeQuestions } = useSelector((state) => state.questions);

  useEffect(() => {
    dispatch(fetchActiveQuestions());
  }, [dispatch]);

  useEffect(() => {
    if (activeQuestions) {
      const formatted = activeQuestions.map((q) => ({
        label: q.question,
        value: q.id,
      }));

      setOptions(formatted);
    }
  }, [activeQuestions]);

  const handleSelectedIds = (ids) => {
    setSelectedQuestionIds(ids);
  };

  const jwtToken = localStorage.getItem("jwt_token");
  const id = paramIdSeprator(search);

  const addCountryPdfSection = () => {
    const nextSectionId = search
      ? Math.max(0, ...countryPdfSections.map((section) => section.sectionId || 0)) + 1
      : countryPdfSections.length + 1;

    setCountryPdfSections((prev) => [
      ...prev,
      createCountryPdfSection(nextSectionId),
    ]);
  };

  const removeCountryPdfSection = (sectionId) => {
    setCountryPdfSections((prev) => {
      if (prev.length === 1) return prev;
      const filteredSections = prev.filter((section) => section.id !== sectionId);

      if (search) {
        return filteredSections;
      }

      return filteredSections.map((section, index) => ({
        ...section,
        id: index + 1,
        sectionId: index + 1,
      }));
    });
  };

  const updateCountryPdfSection = (sectionId, key, value) => {
    setCountryPdfSections((prev) =>
      prev.map((section) =>
        section.id === sectionId ? { ...section, [key]: value } : section,
      ),
    );
    setSectionErrors((prev) => ({
      ...prev,
      [sectionId]: {
        ...prev[sectionId],
        [key]: "",
      },
    }));
  };

  const validateAdditionalSections = () => {
    const nextErrors = {};

    countryPdfSections.forEach((section) => {
      if (!section.countries || section.countries.length === 0) {
        nextErrors[section.id] = {
          ...nextErrors[section.id],
          countries: "Target Country is required",
        };
      }
    });

    setSectionErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const buildCountryPdfPayload = (sections) =>
    sections.map((section, index) => ({
      order: index + 1,
      target_country: getLabels(section.countries),
      standard_or_tailored: section.standard?.label || "",
      version: section.version || "",
      front_pdf:
        typeof section.frontFile === "string" ? section.frontFile : null,
      back_pdf: typeof section.backFile === "string" ? section.backFile : null,
    }));

  const appendPdfField = (bodyFormData, key, value) => {
    if (!value) {
      bodyFormData.append(key, "none");
      return;
    }

    bodyFormData.append(key, value);
  };

  const getCountrySectionTargetCountry = (section) => {
    const labels = getLabels(section.countries);
    return labels.join(", ");
  };

  const extractCardIdFromResponse = (responseData) =>
    responseData?.card_id ||
    responseData?.id ||
    responseData?.data?.card_id ||
    responseData?.data?.id ||
    responseData?.data?.actioncard_id ||
    responseData?.data?.action_id ||
    null;

  const submitActionCardPdfSections = async (cardId, isUpdate = false) => {
    const pdfUrl = `${process.env.REACT_APP_API_URL}/actioncard-pdf`;
    const pdfFormData = new FormData();
    const countrySectionsPayload = countryPdfSections.map((section, index) => {
      const resolvedSectionId =
        isUpdate && section.sectionId ? section.sectionId : index + 1;

      appendPdfField(
        pdfFormData,
        `front_pdf_${resolvedSectionId}`,
        section.frontFile,
      );
      appendPdfField(
        pdfFormData,
        `back_pdf_${resolvedSectionId}`,
        section.backFile,
      );

      return {
        section_id: resolvedSectionId,
        target_country: getCountrySectionTargetCountry(section),
        standard_and_tailored: section.standard?.label || "",
        version: section.version || 0,
      };
    });

    pdfFormData.append("card_id", cardId);
    pdfFormData.append(
      "country_sections",
      JSON.stringify(countrySectionsPayload),
    );

    const pdfResponse = await fetch(pdfUrl, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      body: pdfFormData,
    });

    return pdfResponse.json();
  };

  const appendCountryPdfSections = (bodyFormData) => {
    bodyFormData.append("target_country", JSON.stringify(getLabels(countrys)));
    bodyFormData.append("standard_or_tailored", standards?.label || "");
    bodyFormData.append("version", versionNumber || "");
    appendPdfField(bodyFormData, "front_pdf", frontFile);
    appendPdfField(bodyFormData, "back_pdf", backFile);
  };

  const appendCommonFormData = (bodyFormData) => {
    bodyFormData.append("english_name", engName);
    bodyFormData.append("english_short_name", engShortName);
    bodyFormData.append("danish_name", danishName);
    bodyFormData.append("danish_short_name", danishShortName);
    bodyFormData.append("client_type", JSON.stringify(getLabels(clientTypes)));
    bodyFormData.append("format", JSON.stringify(getLabels(formats)));
    bodyFormData.append("purpose_type", purposes?.label || "");
    bodyFormData.append("language", JSON.stringify(getLabels(langs)));
    bodyFormData.append("remarks", remark);
    bodyFormData.append("ac_no", ac_no);

    files.forEach((file) => bodyFormData.append("ac_document", file));

    appendCountryPdfSections(bodyFormData);
    bodyFormData.append("question_ids", JSON.stringify(selectedQuestionIds));
  };

  useEffect(() => {
    AcNumberInAddData();
    if (id) {
      update(id);
    }
  }, []);

  const postDataApi = async () => {
    const url = `${process.env.REACT_APP_API_URL}/actioncard`;
    const bodyFormData = new FormData();

    appendCommonFormData(bodyFormData);
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
        body: bodyFormData,
      });
      const data = await response.json();

      if (data.error) {
        toast.error(data.error);
        return;
      }

      const cardId = extractCardIdFromResponse(data);
      if (!cardId) {
        toast.error("Action card created but card_id not found for PDF upload");
        return;
      }

      const pdfData = await submitActionCardPdfSections(cardId, false);
      if (pdfData.error) {
        toast.error(pdfData.error);
        return;
      }

      toast.success("Data Added");
      history.push("/single-action");
    } catch {
      toast.error("Something went wrong");
    }
  };

  const update = async (actionCardId) => {
    const url = `${process.env.REACT_APP_API_URL}/actioncard/${actionCardId}`;
    fetch(url, {
      method: "get",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data.data.actioncard_details;

        setEngName(codeMessage.english_name);
        setEngShortName(codeMessage.english_short_name);
        setDanishName(codeMessage.danish_name);
        setDanishShortName(codeMessage.danish_short_name);
        setRemark(codeMessage.remarks);

        setClientTypes(
          normalizeMultiSelectValue(codeMessage.client_type, ClientType),
        );
        setFormats(normalizeMultiSelectValue(codeMessage.format, Format));
        setLangs(normalizeMultiSelectValue(codeMessage.language, Lang));

        setPurposes(
          codeMessage.purpose_type
            ? findOption(Purpose, codeMessage.purpose_type)
            : null,
        );
        setCountrys(
          normalizeMultiSelectValue(codeMessage.target_company, Country),
        );
        setStandards(
          findOption(
            Standard,
            codeMessage.standard_and_tailored || codeMessage.standard_or_tailored,
          ) || Standard[0],
        );
        setVersionNumber(
          codeMessage.version !== undefined && codeMessage.version !== null
            ? String(codeMessage.version)
            : "",
        );
        setFrontFile(codeMessage.front_pdf || null);
        setBackFile(codeMessage.back_pdf || null);
        setDefaultSectionId(1);

        setAc_no(codeMessage.ac_no);

        if (codeMessage.question_ids) {
          const ids = Array.isArray(codeMessage.question_ids)
            ? codeMessage.question_ids
            : JSON.parse(codeMessage.question_ids);

          setSelectedQuestionIds(ids);
          setDefaultQuestionIds(ids);
        }

        const defaultTargetCountry = Array.isArray(codeMessage.target_company)
          ? codeMessage.target_company.join(", ")
          : `${codeMessage.target_company || ""}`;
        const defaultStandardValue =
          codeMessage.standard_and_tailored || codeMessage.standard_or_tailored || "";
        const defaultVersionValue =
          codeMessage.version !== undefined && codeMessage.version !== null
            ? String(codeMessage.version)
            : "";
        const countrySectionSource = Array.isArray(codeMessage.country_section)
          ? codeMessage.country_section
          : [];

        const filteredCountrySections = countrySectionSource.filter((section) => {
          const sectionTargetCountry = `${section.target_country || ""}`;
          const sectionStandardValue =
            section.standard_and_tailored || section.standard_or_tailored || "";
          const sectionVersionValue =
            section.version !== undefined && section.version !== null
              ? String(section.version)
              : "";

          const looksLikeDefaultSection =
            sectionTargetCountry === defaultTargetCountry &&
            sectionStandardValue === defaultStandardValue &&
            sectionVersionValue === defaultVersionValue &&
            !section.front_pdf &&
            !section.back_pdf;

          return !looksLikeDefaultSection;
        });

        const hydratedSections = filteredCountrySections.map((section, index) =>
          createCountryPdfSection(section.section_id || section.sectionId || index + 1, {
            sectionId: section.section_id || section.sectionId || index + 1,
            countries: normalizeMultiSelectValue(
              section.target_country ||
                section.target_company,
              Country,
            ),
            standard:
              findOption(
                Standard,
                section.standard_or_tailored ||
                  section.standard_and_tailored,
              ) || Standard[0],
            version:
              section.version !== undefined && section.version !== null
                ? String(section.version)
                : "",
            frontFile: section.front_pdf || null,
            backFile: section.back_pdf || null,
          }),
        );

        setDefaultSectionId(1);

        setCountryPdfSections(
          hydratedSections.length
            ? hydratedSections
            : [],
        );
      });
  };

  const UpdateDataApi = async () => {
    const url = `${process.env.REACT_APP_API_URL}/actioncard/${id}`;
    const bodyFormData = new FormData();

    appendCommonFormData(bodyFormData);
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
        body: bodyFormData,
      });
      const data = await response.json();

      if (data.error) {
        toast.error(data.error);
        return;
      }

      const pdfData = await submitActionCardPdfSections(id, true);
      if (pdfData.error) {
        toast.error(pdfData.error);
        return;
      }

      toast.success("Data Updated Successfully");
      history.push("/single-action");
    } catch {
      toast.error("Something went wrong");
    }
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (!validateAdditionalSections()) return;
    if (search) {
      UpdateDataApi();
    } else {
      postDataApi();
    }
  };

  const AcNumberInAddData = async () => {
    const url = `${process.env.REACT_APP_API_URL}/ac-number`;
    await fetch(url, {
      method: "get",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data.data;
        setAc_no(codeMessage);
      });
  };

  return (
    <>
      <h4>{paramIdSeprator(search) ? "Update" : "Add"} ActionCard</h4>

      <form onSubmit={onSubmitHandler}>
        <div className="row mb-3 align-items-center">
          <label className="col-md-2 col-form-label">AC No</label>
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              value={ac_no}
              onChange={(e) => setAc_no(e.target.value)}
            />
          </div>
        </div>
        <hr style={{ color: "red" }} />

        <div className="row mb-3">
          <div className="col-md-6">
            <label>English Name</label>
            <input
              className="form-control"
              value={engName}
              onChange={(e) => setEngName(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label>Danish Name</label>
            <input
              className="form-control"
              value={danishName}
              onChange={(e) => setDanishName(e.target.value)}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label>Short English Name</label>
            <input
              className="form-control"
              value={engShortName}
              onChange={(e) => setEngShortName(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label>Short Danish Name</label>
            <input
              className="form-control"
              value={danishShortName}
              onChange={(e) => setDanishShortName(e.target.value)}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label>Purpose Type</label>
            <Select
              value={purposes}
              options={Purpose}
              onChange={setPurposes}
              isClearable
            />
          </div>

          <div className="col-md-6">
            <label>Format</label>
            <Select
              isMulti
              value={formats}
              options={Format}
              onChange={(value) => setFormats(value || [])}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label>Client Type</label>
            <Select
              isMulti
              value={clientTypes}
              options={ClientType}
              onChange={(value) => setClientTypes(value || [])}
            />
          </div>
          <div className="col-md-6">
            <label>Remarks</label>
            <textarea
              className="form-control"
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </div>
        </div>

        <hr style={{ color: "red" }} />

        <div className="row mb-3">
          <div className="col-md-4">
            <label>Target Country</label>
            <Select
              isMulti
              value={countrys}
              options={Country}
              onChange={(value) => setCountrys(value || [])}
            />
          </div>

          <div className="col-md-4">
            <label>Standard/Tailored</label>
            <Select
              value={standards}
              options={Standard}
              onChange={(value) => setStandards(value || Standard[0])}
            />
          </div>

          <div className="col-md-4">
            <label>Version</label>
            <input
              type="text"
              className="form-control"
              value={versionNumber}
              onChange={(e) => setVersionNumber(e.target.value)}
            />
          </div>
        </div>

        <hr style={{ color: "red" }} />

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="mb-1">Additional Country Sections</h5>
            <small className="text-muted">
              Add extra sections for another country and PDF upload.
            </small>
          </div>
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={addCountryPdfSection}
          >
            + Add Section
          </button>
        </div>

        {countryPdfSections.map((section, index) => (
          <div
            key={section.id}
            className="mb-4 p-3 p-md-4"
            style={{
              border: "1px solid #f2caca",
              borderRadius: "14px",
              backgroundColor: "#fffdfd",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h6 className="mb-1">Section {index + 1}</h6>
                <small className="text-muted">
                  Additional country PDF section
                </small>
              </div>
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => removeCountryPdfSection(section.id)}
              >
                - Remove
              </button>
            </div>

            <div className="row mb-3">
              <div className="col-md-4">
                <label>Target Country</label>
                <Select
                  value={section.countries?.[0] || null}
                  options={Country}
                  onChange={(value) =>
                    updateCountryPdfSection(
                      section.id,
                      "countries",
                      value ? [value] : [],
                    )
                  }
                />
                {sectionErrors[section.id]?.countries && (
                  <small className="text-danger d-block mt-1">
                    {sectionErrors[section.id].countries}
                  </small>
                )}
              </div>

              <div className="col-md-4">
                <label>Standard/Tailored</label>
                <Select
                  value={section.standard}
                  options={Standard}
                  onChange={(value) =>
                    updateCountryPdfSection(
                      section.id,
                      "standard",
                      value || Standard[0],
                    )
                  }
                />
              </div>

              <div className="col-md-4">
                <label>Version</label>
                <input
                  type="text"
                  className="form-control"
                  value={section.version}
                  onChange={(e) =>
                    updateCountryPdfSection(
                      section.id,
                      "version",
                      e.target.value,
                    )
                  }
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-12 col-md-6 mb-3">
                <FileUploadBox
                  label="Front PDF"
                  file={section.frontFile}
                  setFile={(value) =>
                    updateCountryPdfSection(section.id, "frontFile", value)
                  }
                  inputId={`frontFileInput_${section.id}`}
                />
              </div>

              <div className="col-12 col-md-6 mb-3">
                <FileUploadBox
                  label="Back PDF"
                  file={section.backFile}
                  setFile={(value) =>
                    updateCountryPdfSection(section.id, "backFile", value)
                  }
                  inputId={`backFileInput_${section.id}`}
                />
              </div>
            </div>
          </div>
        ))}

        <hr style={{ color: "red" }} />

        <label>Select Questions: </label>
        <DraggableSelectList
          options={options}
          defaultValues={defaultQuestionIds}
          onChange={handleSelectedIds}
        />
        <hr style={{ color: "red" }} />

        <div className="text-center">
          <button type="submit" className="btn bg_color px-4">
            {paramIdSeprator(search) ? "Update" : "Add"}
          </button>
        </div>
      </form>
    </>
  );
};

export default AddSingleActionCard;
